import humanizeString from "./humanizeString";

export const formatMetricOrDimensionName = (name: string): string => {
  switch (name) {
    case "ctr":
      return "CTR";
    default:
      return humanizeString(name);
  }
};
